/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = REGISTEREDKEEPER
 *
 * 1 = HOLDER
 *
 * 2 = DRIVER
 */
export enum VehicleRelationshipType {
  REGISTEREDKEEPER = 0,
  HOLDER = 1,
  DRIVER = 2,
}
